//@flow
import { connect } from 'react-redux';
import International from './International';
import { setRoamingCountry } from '../../modules/International/Roaming/actions';

const mapDispatchToProps = { setRoamingCountry };

export default connect(null, mapDispatchToProps)(International);
